import { render, staticRenderFns } from "./ImageStyle.vue?vue&type=template&id=ed9c5ce2&"
import script from "./ImageStyle.vue?vue&type=script&lang=ts&"
export * from "./ImageStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports